import React, { ForwardedRef } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './icon.component';

const CheckboxWithIcon = React.forwardRef(
  (
    {
      type = 'primary',
      icon = '',
      title = '',
      subtitle = '',
      required = false,
      value = '',
      checked,
      onChange
    }: any,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { t } = useTranslation();

    return (
      <div className="d-flex flex-stack cursor-pointer mb-5" ref={ref}>
        <span className="d-flex align-items-center me-2">
          <span className="symbol symbol-circle symbol-50px me-6">
            <span className={`symbol-label bg-light-${type}`}>
              <Icon icon={icon} size="fs-2x" type={type} />
            </span>
          </span>
          <span className="d-flex flex-column">
            <span className="fw-bold fs-6">
              {title}
              {required ? (
                <label className="form-label required "></label>
              ) : (
                <span className="fs-8 text-muted ms-1">({t('general.optional')})</span>
              )}
            </span>
            <span className="fs-7 text-muted">{subtitle}</span>
          </span>
        </span>
        <span className="form-check form-check-custom form-check-solid">
          <input
            className="form-check-input st-b"
            name="framework"
            checked={checked}
            type="checkbox"
            onChange={onChange}
            value={value}
          />
        </span>
      </div>
    );
  }
);

export default CheckboxWithIcon;
